import BannerAnnouncement from "./Banner/BannerAnnouncement";
import PopupAnnouncement from "./Popup/PopupAnnouncement";
import ViewPopupAnnouncement from "./Popup/ViewPopupAnnouncement";
import MobileNotification from "./MobileNotification/MobileNotification";
import VideoManagement from "./VideoManagement/VideoManagement";
import ViewVideoDetails from "./VideoManagement/ViewVideoDetails";

export const BANNER_ANNOUNCEMENT = "/bannerAnnouncement";
export const POPUP_ANNOUNCEMENT = "/popupAnnouncement";
export const MOBILE_NOTIFICATION = "/mobileNotification";
export const VIDEO_MANAGEMENT = "/videoManagement";
export const VIEW_POPUP_ANNOUNCEMENT = POPUP_ANNOUNCEMENT + "/view";
export const NEW_POPUP_ANNOUNCEMENT = POPUP_ANNOUNCEMENT + "/new";
export const VIEW_VIDEO_DETAILS = VIDEO_MANAGEMENT + "/view";
export const NEW_VIDEO_DETAILS = VIDEO_MANAGEMENT + "/new"
export const routes = [
    {
        path: BANNER_ANNOUNCEMENT,
        component: BannerAnnouncement,
        exact: true
    },
    {
        path: POPUP_ANNOUNCEMENT,
        component: PopupAnnouncement,
        exact: true
    },
    {
        path: MOBILE_NOTIFICATION,
        component: MobileNotification,
        exact: true
    },
    {
        path: VIDEO_MANAGEMENT,
        component: VideoManagement,
        exact: true
    },
    {
        path: VIEW_POPUP_ANNOUNCEMENT + "/:id",
        component: ViewPopupAnnouncement,
        exact: true
    },
    {
        path: NEW_POPUP_ANNOUNCEMENT,
        component: ViewPopupAnnouncement,
        exact: true
    },
    {
        path: VIEW_VIDEO_DETAILS + "/:id",
        component: ViewVideoDetails,
        exact: true
    },
    {
        path: NEW_VIDEO_DETAILS,
        component: ViewVideoDetails,
        exact: true
    }
];